import {
  addDoc as fsAddDoc,
  collection,
  collectionGroup,
  deleteDoc as fsDeleteDoc,
  doc,
  documentId,
  getCountFromServer as fsGetCountFromServer,
  getDoc as fsGetDoc,
  getDocs as fsGetDocs,
  increment,
  limit,
  onSnapshot,
  orderBy,
  query,
  runTransaction as fsRunTransaction,
  serverTimestamp,
  setDoc as fsSetDoc,
  startAfter,
  updateDoc as fsUpdateDoc,
  where,
  writeBatch,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { normalizeFirestoreError, runWithRetry } from "./requestClient";

const FIRESTORE_RETRIES = 1;
const FIRESTORE_RETRY_DELAY_MS = 300;

const runFirestore = (operationName, op) => {
  return runWithRetry(
    async () => {
      try {
        return await op();
      } catch (error) {
        throw normalizeFirestoreError(error, operationName);
      }
    },
    {
      operationName,
      retries: FIRESTORE_RETRIES,
      retryDelayMs: FIRESTORE_RETRY_DELAY_MS,
      isRetryable: (error) => Boolean(error?.retryable),
    }
  );
};

export const addDoc = (...args) => runFirestore("addDoc", () => fsAddDoc(...args));
export const setDoc = (...args) => runFirestore("setDoc", () => fsSetDoc(...args));
export const updateDoc = (...args) => runFirestore("updateDoc", () => fsUpdateDoc(...args));
export const deleteDoc = (...args) => runFirestore("deleteDoc", () => fsDeleteDoc(...args));
export const getDoc = (...args) => runFirestore("getDoc", () => fsGetDoc(...args));
export const getDocs = (...args) => runFirestore("getDocs", () => fsGetDocs(...args));
export const getCountFromServer = (...args) => runFirestore("getCountFromServer", () => fsGetCountFromServer(...args));
export const runTransaction = (...args) => runFirestore("runTransaction", () => fsRunTransaction(...args));

export {
  arrayRemove,
  arrayUnion,
  collection,
  collectionGroup,
  doc,
  documentId,
  increment,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  startAfter,
  where,
  writeBatch,
};
